//src/services/notifications.ts
import { api } from "@/lib/apiClient";
import type {
  NotificationPage,
  NotificationReadAllResponse,
  NotificationReadResponse,
} from "@/types/notifications";

export async function listNotifications(params?: {
  page?: number;
  per_page?: number;
  is_read?: boolean;
}) {
  return api.get<NotificationPage>("/notifications", {
    params: {
      page: params?.page ?? 1,
      per_page: params?.per_page ?? 10,
      is_read: typeof params?.is_read === "boolean" ? params.is_read : undefined,
    },
  });
}


export async function markNotificationAsRead(notificationId: string) {
  return api.post<NotificationReadResponse>(`/notifications/${notificationId}/read`);
}

export async function markAllNotificationsAsRead() {
  return api.post<NotificationReadAllResponse>("/notifications/read-all");
}
